import React from "react";
import { ButtonTab } from "staysure-component-library";

import Styles from "./ButtonTabWrapper.module.css";

type Tab = Readonly<{
  id: string;
  label: string;
  className?: string;
  value: string;
}>;

type ButtonTabWrapperProps = Readonly<{
  defaultActiveTab?: string;
  className?: string;
  tabs: Tab[];
  onClick?: (e: string | number) => undefined | void;
  isDefaultTogle?: boolean;
  isDisabled?: boolean;
}>;

function ButtonTabWrapper({
  defaultActiveTab,
  className,
  tabs,
  isDefaultTogle = true,
  onClick,
  isDisabled = false,
}: Readonly<ButtonTabWrapperProps>) {
  return (
    <ButtonTab
      tabs={tabs}
      className={`${className} ${Styles.ToggleBtn}  rounded-radius-pill items-center justify-center`}
      onClick={onClick}
      defaultActiveTab={defaultActiveTab}
      isDefaultTogle={isDefaultTogle}
      isDisabled={isDisabled}
    />
  );
}

export default ButtonTabWrapper;
